import { Component } from "react";

// Minimal error boundary: when its subtree throws (e.g. a WebGL/GLB failure in the 3D viewer) it renders `fallback`
// instead of crashing the page. `resetKey` lets the parent re-mount the subtree after the cause changes (new URL).
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    this.props.onError?.(error);
  }

  componentDidUpdate(prev) {
    if (prev.resetKey !== this.props.resetKey && this.state.hasError) this.setState({ hasError: false });
  }

  render() {
    if (this.state.hasError) return this.props.fallback ?? null;
    return this.props.children;
  }
}
